import { render, staticRenderFns } from "./StyleGuide.vue?vue&type=template&id=4a3e30bd&"
import script from "./StyleGuide.vue?vue&type=script&lang=js&"
export * from "./StyleGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports